import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { isEqual } from 'lodash'
import ReactSVG from 'react-svg'
import ReactGA from 'react-ga'
import * as routingActions from '../../../routing/dux/'
import Button from '../../../../shared/components/Button/Button'
import JeffLogo from '../../../../assets/JeffVet_logo_lockup_1.svg'
import './Home.scss'

const Home = React.memo(({ page }) => {
  const dispatch = useDispatch()
  let link

  const setPage = () => {
    trackLink('Click to Start', 'Get Started')
    return dispatch(routingActions.setPage(page + 1))
  }
  const trackLink = (action = '', label = '') => {
    ReactGA.event({
      category: 'Homepage',
      action,
      label
    })
  }
  const comCareLink = () => trackLink('Click for Into', 'Community Care')

  // Chrome doesn't recognize middle wheel click
  // as a onClick and react doesn't have auxClick event
  const setRef = linkRef => {
    if (linkRef) {
      link = linkRef
      link.addEventListener('auxclick', comCareLink)
    } else {
      link.removeEventListener('auxclick', comCareLink)
    }
  }

  return (
    <div className="landing">
      <div className="details">
        <div className="text">
          <ReactSVG
            src={JeffLogo}
          />
          <div className="italic">You served our country.</div>
          <div className="italic p-b-1">Now it’s our turn to serve you.</div>
          <div className="p-b-1">
            {'Jefferson Health provides veterans comprehensive care through JeffVet — a program made possible by The Mission Act that expands access to medical treatment for former service members. That means if you’re enrolled in Veterans Affairs health benefits, you can use JeffVet to schedule appointments and receive personalized, compassionate care at Jefferson Health.'}
          </div>
          <div>
            {'JeffVet is designed to give you more healthcare options and help you see a doctor sooner. For quick checkups, specialist visits and everything in between, JeffVet makes it easier to get quality health services wherever and whenever you need them.'}
          </div>
          <div className="p-t-1">
            For more information please visit
            &nbsp;<a
              href="//www.va.gov/communitycare"
              onClick={comCareLink}
              ref={setRef}
            >
            Community Care Overview
            </a>
          </div>
        </div>
      </div>
      <div className="actions">
        <div>
          <Button
            className="landing-btn"
            color="blue-fill"
            onClick={setPage}
          >Get Started</Button>
        </div>
      </div>
    </div>
  )
}, isEqual)


Home.displayName = 'Home'

Home.defaultProps = {
  page: 0,
}

Home.propTypes = {
  page: PropTypes.number,
}

export default Home
